<template>
  <router-view></router-view>
</template>

<script>
export default {};
</script>

<style>
@font-face {
  font-family: "TTNorms-Regular";
  src: url("~@/assets/fonts/TTNorms-Regular.otf");
}

@font-face {
  font-family: "TTNorms-Bold";
  src: url("~@/assets/fonts/TTNorms-Bold.otf");
}

@media (min-width: 1200px) {
  .sidenav.fixed-start + .main-content {
    margin-left: 15.5rem !important;
  }
}

body, *{
  font-family: 'TTNorms-Regular' !important;
}
</style>
